import { useEffect, useRef } from "react";
import { a11yPanel } from "@vitalsource/a11y-panel/index";

export default function A11yPanel({
  vbid,
  locale,
  theme,
  dev,
}: {
  vbid: string;
  locale: string;
  theme: string;
  dev: boolean;
}) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      const panelElement = a11yPanel({ vbid, locale, theme, dev });

      //clears any previous content and append new or updated panel
      containerRef.current.replaceChildren(panelElement);
    }
  }, [vbid, locale, theme, dev]);

  return <div ref={containerRef} />;
}
